module.exports = __webpack_public_path__ + "img/main4.205a364c.jpg";